import { ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import * as store from "../../framework/customStore";

export class StoreUtils {
    static getNowModifyUser(data: number = null): ModifyUser {
        const result = new ModifyUser();
        result.date = data ?? new Date().getTime();
        const appState = store.customStore.getState();
        if (!appState || !appState.user || !appState.user) return result;
        const user = appState.user;
        result.code = user.userCode;
        result.name = user.userName;
        if (user.userPicture) {
            result.picture = "data:image/png;base64," + user.userPicture;
        }
        return result;
    }
}